import { useState, useEffect } from "react";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery: MediaQueryList = window.matchMedia(
      "(max-width: 575.98px)",
    );
    setIsMobile(mediaQuery.matches);

    const handleMediaChange = (event: MediaQueryListEvent): void => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", handleMediaChange);
    return (): void => {
      mediaQuery.removeEventListener("change", handleMediaChange);
    };
  }, []);

  return isMobile;
}
